/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-05 17:34:19
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-25 18:13:26
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\cells\SupplierPlatformPriceCell\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useMemo } from 'react';
import { CellDescriptions } from '@mpc/components';
import { ItemVo } from '#services/api';
import { DescriptionsItemType } from '@bedrock/components/lib/Descriptions/Item';
import { Button, Form, Popconfirm } from '@bedrock/components';
import { FormItemRow, FormItemProp } from '#components/SForm/createFormItemRow';
import { Edit } from '@bedrock/icons-react';
import { useMemoizedFn } from 'ahooks';
import classNames from 'classnames/bind';
import styles from './index.less';
import { thousandSeparatorConfig } from '../useDesignatedExpertColumns';
import { useDemandOptions } from "@mpc/common/src/features/useDemandOptions";
const cx = classNames.bind(styles);
export const PopoverForm = ({ children, initialValue, onOk, itemCols, title, ...restProps }: React.ComponentProps<typeof Popconfirm> & { children: React.ReactNode, initialValue: Record<string, any>, onOk: (value: Record<string, any>) => void, itemCols: FormItemProp[], title: React.ReactNode }) => {
  const [form] = Form.useForm();

  const itemColsLocal = useMemo(() => {
    return itemCols?.map((item) => ({
      ...item,
      labelClassName: 'w-[88px]',
    })) || [];
  }, [itemCols]);

  const formContent = <div className="px-3" >
    {Array.isArray(itemCols) && itemCols.length > 0 && (
      <Form form={form} layout="horizontal" showLabelColon>
        <FormItemRow formItemMap={{}} itemCols={itemColsLocal as any} />
      </Form>
    )}
  </div>;

  return <Popconfirm
    overlayClassName={cx('popover-form-layout',restProps.overlayClassName)}
    type="unset"
    placement="leftTop"
    {...restProps}
    onVisibleChange={(visible) => {
      if (visible) {
        form.setFieldsValue(initialValue);
      }
    }}
    title={title}
    content={formContent}
    cancelText="重置"
    onCancel={() => {
      form.setFieldsValue({});
      onOk?.({});
    }}
    onOk={() => {
      onOk(form.getFieldsValue());
    }}>
    {children}
  </Popconfirm>
}


// 业务组件类型
type CellItemVo = {
  value: string | number;
} & Omit<ItemVo, 'value'>

// 平台价格组件属性类型
type ItemColsConfig = {
  l3_category_id: number;
  category_name: string;
  type: 'price' | 'cpm';
  title: string;
  items: CellItemVo[];
};

// TODO: 远程获取，稳定后删除此配置
// 默认平台价格组件属性
const defaultItemColsConfig: ItemColsConfig[] = [
  // 平台价格
  {
    // 三级需求类型
    l3_category_id: 221011,
    category_name: '视频图文',
    type: 'price',
    title: '平台价格',
    items: [
      {
        name: '1-20s',
        value: '',
        alias: 'price_1_20s',
      },
      {
        name: '21-60s',
        value: '',
        alias: 'price_21_60s',
      },
      {
        name: '60s+',
        value: '',
        alias: 'price_60s+',
      },
      {
        name: '供稿发布',
        value: '',
        alias: 'price_供稿发布',
      },
      {
        name: '产出发布',
        value: '',
        alias: 'price_产出发布',
      },
    ],
  },
  {
    l3_category_id: 221010,
    category_name: '直播',
    type: 'price',
    title: '平台价格',
    items: [
      {
        name: '1小时',
        value: '',
        alias: 'price_1h',
      },
      {
        name: '2小时',
        value: '',
        alias: 'price_2h',
      },
      {
        name: '5小时',
        value: '',
        alias: 'price_5h',
      },
      {
        name: '10小时',
        value: '',
        alias: 'price_10h',
      },
    ],
  },
  // 平台CPM
  {
    // 三级需求类型
    l3_category_id: 221011,
    category_name: '视频图文',
    type: 'cpm',
    title: '平台CPM',
    items: [
      {
        name: '1-20s',
        value: '',
        alias: 'cpm_1_20s',
      },
      {
        name: '21-60s',
        value: '',
        alias: 'cpm_21_60s',
      },
      {
        name: '60s+',
        value: '',
        alias: 'cpm_60s+',
      },
      {
        name: '供稿发布',
        value: '',
        alias: 'cpm_gonggaofabu',
      },
      {
        name: '产出发布',
        value: '',
        alias: 'cpm_chanchafabu',
      },
    ],
  },
  {
    l3_category_id: 221010,
    category_name: '直播',
    type: 'cpm',
    title: '平台CPM',
    items: [
      {
        name: '1小时',
        value: '',
        alias: 'cpm_1h',
      },
      {
        name: '2小时',
        value: '',
        alias: 'cpm_2h',
      },
      {
        name: '5小时',
        value: '',
        alias: 'cpm_5h',
      },
      {
        name: '10小时',
        value: '',
        alias: 'cpm_10h',
      },
    ],
  },
]
  

// 平台价格组件属性类型
interface SupplierPlatformPriceCellProps {
  /** 平台价格 数组） */
  l3_category_id?: number;
  type?: 'price' | 'cpm';
  value?: CellItemVo[];
  view?: boolean;
  initItems?: CellItemVo[];
  onChange?: (value: CellItemVo[]) => void;
  title?: string;
}

// 平台价格弹窗表单
const PlatformPopoverForm = ({ children, initialValue, onOk, l3_category_id, type, title, initItems }: { 
  children: React.ReactNode, 
  initialValue: CellItemVo[],
  onOk: (value: CellItemVo[]) => void,
  l3_category_id: number,
  type: 'price' | 'cpm',
  title?: string;
  initItems?: CellItemVo[];
}) => {
  const { optionsMap } = useDemandOptions({
    keys: ['platform_price_config', 'platform_cpm_config'],
    params: {
      l3_category_id,
    }
  });

  const itemColsConfigItem = useMemo(() => {
    const remoteItems = optionsMap[type === 'price' ? 'platform_price_config' : 'platform_cpm_config']?.options;
    if (remoteItems?.length) {
      return remoteItems.map(n => {
        return {
          name: n.name,
          alias: n.value,
        }
      });
    }
    return [];
    // return defaultItemColsConfig.find((item) => item.l3_category_id === l3_category_id && item.type === type)?.items || [];
  }, [l3_category_id, type, optionsMap]);

  const popoverFormItemCols = useMemo(() => {
    return itemColsConfigItem.map((item) => ({
      label: item.name,
      componentClass: 'inputNumber',
      formItemKey: item.alias,
      elementProps: {
        ...thousandSeparatorConfig
      }
    } as FormItemProp));
  }, [itemColsConfigItem]);

  const popoverFormItemValues = useMemo(() => {
    return initialValue.reduce((acc, item) => {
      acc[item.alias] = item.value;
      return acc;
    }, {} as Record<string, any>) || {};
  }, [initialValue]);

  const handleOk = useMemoizedFn((formValues: Record<string, any>) => {
    const values = itemColsConfigItem.map((item) => ({
      ...item,
      value: formValues[item.alias],
    })) as CellItemVo[];
    onOk?.(values || []);
  });

  return <PopoverForm
      initialValue={popoverFormItemValues} 
      onOk={handleOk} 
      itemCols={popoverFormItemCols as FormItemProp[]} 
      title={title}
    >
    {children}
  </PopoverForm>
}

/**
 * 平台价格信息展示组件
 * 使用 CompositePlatformField 实现复合字段逻辑
 */
export const SupplierPlatformPriceCell: React.FC<SupplierPlatformPriceCellProps> = ({
  l3_category_id = 221010,
  type = 'price',
  value = [],
  view = false,
  initItems = [],
  title = '',
  onChange,
}) => {
  const items = value.map((item) => ({
    label: item.name,
    children: item.value !== undefined ? thousandSeparatorConfig.formatter(item.value) : '--',
  }));

  const handleChange = useMemoizedFn((values: CellItemVo[]) => {
    onChange?.(values);
  });

  const isEmpty = useMemo(() => {
    return value.every((item) => item.value === '' || item.value === null || item.value === undefined);
  }, [value]);

  return <div className="flex items-center gap-2 justify-between w-full">
    {isEmpty ? 
      <div className="text-sm text-gray-500">--</div> : 
      <div className="flex-1"><CellDescriptions items={items as DescriptionsItemType[]} maxDisplayCount={3}/></div>}
      {!view && (
        <PlatformPopoverForm
          initialValue={value as CellItemVo[]}
          onOk={handleChange}
          l3_category_id={l3_category_id}
          initItems={initItems}
          type={type}
          title={title}
        >
          <Button type="checked-neutral" size="xSmall" icon={<Edit />} className="flex-shrink-0" />
        </PlatformPopoverForm>
      )}
    </div>
};
